import React from 'react';
import { IImageProps, Image } from '@hotelplan/components.common.image';
import { MapLoader } from '@hotelplan/components.common.map';
import { useObjectId } from '@hotelplan/libs.context.object-id';

interface IPdpDescriptionStaticMapProps {
  className?: string;
  staticMaps?: IImageProps[];
  loading?: boolean;
}

const PdpDescriptionStaticMap = ({
  loading,
  className,
  staticMaps,
}: IPdpDescriptionStaticMapProps) => {
  const { id } = useObjectId();

  if (loading) return <MapLoader />;

  if (!staticMaps?.length) return null;

  const map = staticMaps[0];

  return (
    <div
      id={`pdp-${id}-static-map`}
      className={className}
      data-id="pdp-static-map"
    >
      <Image resized={map.resized} alt={map.alt} />
    </div>
  );
};

export default PdpDescriptionStaticMap;
